import { GROUP_METRICS_CLASS } from "../../Dashboard/Tiles/ProcessTile/ProcessTilesPanelStyles";
import { START_OF_TOUR_PROPS } from "./START_OF_TOUR_PROPS";
import { getIsIe11 } from "constants/constants";

const isInternetExplorer = getIsIe11();

export const JOYRIDE_TIMELINE_STEPS = [
  {
    ...START_OF_TOUR_PROPS,
    content: (
      <>
        <div>Hey, welcome to Raven{`'`}s Timeline page!</div>
        <div>
          Since there{`'`}s a lot going on here, we thought we{`'`}d offer to
          show you around.
        </div>
        <div>
          Click {`"`}Next{`"`} to continue...
        </div>
      </>
    ),
  },
  {
    target: ".daySelector",
    disableScrolling: true,
    spotlightPadding: -5,
    content: (
      <>
        <div>
          You can use this <span className="bold">day selector</span> to
          navigate days.
        </div>
        <div>Click on the date for a full day (24 hour) view.</div>
      </>
    ),
  },
  {
    target: ".datepicker",
    disableScrolling: true,
    content: (
      <>
        <div>
          Here{`'`}s a <span className="bold">date picker</span> if you want to
          go to a specific date.
        </div>
      </>
    ),
  },
  {
    target: ".shiftSelector",
    disableScrolling: true,
    spotlightPadding: -5,
    content: (
      <>
        <div>
          This <span className="bold">shift selector</span> shows shifts as
          circles, for days with more than one shift.
        </div>
      </>
    ),
  },
  {
    target: `.${GROUP_METRICS_CLASS}`,
    disableScrolling: true,
    spotlightPadding: -10,
    content: (
      <>
        <div>
          This section is customizable in the{" "}
          <span className="bold">Settings</span> menu: it can include{" "}
          <span className="bold">summary metrics</span> for the group,{" "}
          <span className="bold">Butterfly</span>,{" "}
          <span className="bold">Trend</span>, and{" "}
          <span className="bold">P&L Breakdown</span> charts.
        </div>
        <div>
          (This tour will only go through charts that are currently visible.)
        </div>
      </>
    ),
  },
  {
    target: ".babyButterfly",
    content: (
      <>
        <div>
          Here{`'`}s the <span className="bold">Butterfly</span> chart.
        </div>
        <div>
          You can <span className="bold">hover or click</span> here to see a
          quick summary of all the P&L categories for the selected shift or day.
        </div>
      </>
    ),
  },
  {
    target: "[class*=TrendChartStyles]",
    disableScrolling: true,
    content: (
      <>
        <div>
          Here{`'`}s your <span className="bold">Trend</span> chart -- currently
          it shows hourly summaries.
        </div>
        <div>
          <span className="bold">Hover or click</span> a bar for a summary of
          that period.
        </div>
        <div>
          You can also hover or click in the tooltip to highlight segments on
          the timeline.
        </div>
      </>
    ),
  },
  {
    target: `.TimeAxisStyles`,
    disableScrolling: true,
    content: (
      <>
        <div>
          And of course, here{`'`}s your <span className="bold">Timeline</span>!
        </div>
        <div>
          This real-time data visualization tells you the story of what happened
          throughout the shift or day.
        </div>
        <div>
          Click on a time segment to find out more about what happened, and
          when.
        </div>
      </>
    ),
  },
  {
    target: `.processNameLinkWrapper`,
    disableScrolling: true,
    content: (
      <>
        <div>
          Click on a <span className="bold">Process Name</span> to view the
          details and current status of that process.
        </div>
      </>
    ),
  },
  {
    target: isInternetExplorer
      ? `.timeAxisColumn` // can{`'`}t select svgs on ie11
      : `.timeAxisColumn path.outOfFocusPathLeft`,
    disableScrolling: true,
    content: (
      <>
        <div>
          The darker sections on the left and right sides are{" "}
          <span className="bold">outside the current shift or day</span> -- we
          show them here to tell the story of what happened leading up to now.
        </div>
      </>
    ),
  },
  {
    target: `.timeAxisControlsButtonsWrapper`,
    disableScrolling: true,
    content: (
      <>
        <div>
          For your convenience, we{`'`}ve included some buttons to quickly...
        </div>
        <div>1. Return the view to the current shift or day</div>
        <div>
          2. Switch to {`"`}Live View{`"`}, to always follow the current time
        </div>
      </>
    ),
  },
  {
    target: `[aria-label="RightDrawer"] span`,
    content: (
      <>
        <div>
          Finally, there{`'`}s a menu up here where you can change{" "}
          <span className="bold">Settings</span> for all pages, check for{" "}
          <span className="bold">Updates</span> or send us a message through{" "}
          <span className="bold">Help & Feedback</span>.
        </div>
      </>
    ),
  },
  {
    target: `#root`,
    placement: "center" as any,
    content: (
      <>
        <div>
          We{`'`}re hard at work on Raven Flight, to provide value where you
          need it most — so keep the feedback coming, and check back often for
          updates!
        </div>
      </>
    ),
  },
];
